// extracted by mini-css-extract-plugin
export default {"wrapper":"Welcome_wrapper__BbdlN","title":"Welcome_title__LqNyd","texts":"Welcome_texts__b-dwO","subtitle":"Welcome_subtitle__yYNni","description":"Welcome_description__29DSf"};